import { LOG_OUT_USER } from '../../TYPES';

const logOutUser = () => {
  return {
    type: LOG_OUT_USER
  }
};

export default logOutUser